export const heroSlides = [
  {
    kicker: 'SCHOOL ERP • SCHOOL MANAGEMENT SOFTWARE',
    title: 'Turn screen time into meaningful learning',
    highlight: 'meaningful learning',
    text: 'Interactive, CBSE-aligned practice that helps children learn, score, and grow — with daily quizzes and real progress.',
    points: ['Daily practice that feels like play', 'Curriculum-aligned questions', 'Rewards that keep students coming back'],
    primary: { label: 'Explore Learning', to: '/platforms/lms' },
    secondary: { label: 'Start a free trial', to: '/register-for-demo' },
    badge: { value: '7 PM', label: 'Daily quiz. Real rewards.' },
    theme: 'learn',
    image: 'learn',
  },
  {
    kicker: 'LEADERSHIP INTELLIGENCE',
    title: 'Turn school data into decisions leaders can trust',
    highlight: 'decisions leaders can trust',
    text: 'Bring admissions, attendance, academics, and finance into one live view so principals and group heads act faster.',
    points: ['Executive-level school visibility', 'Data-backed planning', 'Campus-wide performance monitoring'],
    primary: { label: 'Explore Intelligence', to: '/school-optimisation/intelligence' },
    secondary: { label: 'Register for Demo', to: '/register-for-demo' },
    badge: { value: 'LIVE', label: 'One dashboard. Every campus.' },
    theme: 'intel',
    image: 'intel',
  },
  {
    kicker: 'SCHOOL AUTOMATION',
    title: 'Reclaim thousands of administrative hours',
    highlight: 'administrative hours',
    text: 'Automate admissions, attendance, fees, communication, and reporting so teams spend time on teaching, not chasing files.',
    points: ['Streamlined admin workflows', 'Fewer operational bottlenecks', 'More time for academic excellence'],
    primary: { label: 'Explore Automation', to: '/school-optimisation/explore-automation' },
    secondary: { label: 'Talk to Sales', to: '/contact-us/connect-with-us' },
    badge: { value: '24/7', label: 'Processes that never sleep.' },
    theme: 'auto',
    image: 'auto',
  },
  {
    kicker: 'AI FOR SCHOOLS',
    title: 'Enable proactive, growth-oriented decision making',
    highlight: 'decision making',
    text: 'Predictive insights help schools spot risk early, plan capacity, and respond before small issues become campus-wide problems.',
    points: ['Early trend and risk detection', 'AI-assisted school planning', 'Faster response to operational challenges'],
    primary: { label: 'Explore AI', to: '/platforms/ai' },
    secondary: { label: 'Register for Demo', to: '/register-for-demo' },
    badge: { value: 'AI', label: 'See what is coming next.' },
    theme: 'ai',
    image: 'ai',
  },
];

export const homeStats = [
  { value: 'ERP', label: 'Admissions, fees, and academics in one system' },
  { value: 'LMS', label: 'Homework, content, and live classes together' },
  { value: 'Apps', label: 'Parents, teachers, and leadership on mobile' },
  { value: 'K-12', label: 'Designed for growing Indian school campuses' },
];

export const offeringTabs = [
  {
    id: 'erp',
    label: 'School ERP',
    tabIcon: 'cog',
    intro: 'One system for academics, administration, people, and finance.',
    items: [
      { title: 'Academics', text: 'Timetables, homework, exams, and results in a single academic flow.', to: '/school-optimisation/academics', icon: 'school' },
      { title: 'Administration', text: 'Cut the paperwork around admissions, attendance, certificates, and daily ops.', to: '/school-optimisation/administration', icon: 'admin' },
      { title: 'Human Resources', text: 'Recruitment, attendance, payroll, and staff records without scattered files.', to: '/school-optimisation/human-resources', icon: 'people' },
      { title: 'Finance', text: 'Fee structures, collections, receipts, and clear reporting for every campus.', to: '/school-optimisation/finance', icon: 'finance' },
    ],
  },
  {
    id: 'app',
    label: 'Mobile App',
    tabIcon: 'phone',
    intro: 'Parents, teachers, and leaders stay connected from anywhere.',
    items: [
      { title: 'Student App', text: 'Circulars, homework, e-learning, fees, and progress in one place.', to: '/platforms/mobile-application', icon: 'phone' },
      { title: 'Teacher App', text: 'Attendance, assignments, remarks, and class communication on the go.', to: '/platforms/mobile-application', icon: 'book' },
      { title: 'Management App', text: 'Live snapshots of admissions, collections, and campus health.', to: '/platforms/ai-analytics-dashboard', icon: 'chart' },
      { title: 'Transport App', text: 'Routes, staff, and parent updates without extra GPS hardware complexity.', to: '/school-optimisation/logistics', icon: 'bus' },
    ],
  },
  {
    id: 'lms',
    label: 'E-Learning',
    tabIcon: 'book',
    intro: 'A complete LMS for live classes, content, and trusted assessments.',
    items: [
      { title: 'Online Classes', text: 'Connect scheduled sessions with Meet or Zoom from the school timetable.', to: '/platforms/lms', icon: 'video' },
      { title: 'Digital Content', text: 'PDFs, video, audio, and notes students can revisit as often as they need.', to: '/platforms/lms', icon: 'folder' },
      { title: 'Online Assessment', text: 'Objective and subjective quizzes with faster evaluation workflows.', to: '/school-optimisation/learning', icon: 'quiz' },
      { title: 'Exam Proctoring', text: 'Run remote tests with integrity checks closer to a classroom exam.', to: '/platforms/ai', icon: 'shield' },
    ],
  },
  {
    id: 'web',
    label: 'Website',
    tabIcon: 'globe',
    intro: 'A modern school website that captures enquiries and tells your story.',
    items: [
      { title: 'Responsive Design', text: 'Fast pages that work cleanly on phones, tablets, and desktops.', to: '/platforms/website', icon: 'devices' },
      { title: 'Dynamic Content', text: 'Notices, galleries, admissions, and calendars stay in sync with the ERP.', to: '/platforms/website', icon: 'feed' },
      { title: 'CMS', text: 'Update pages without waiting on a developer for every small change.', to: '/platforms/website', icon: 'edit' },
      { title: 'SEO & Enquiry Forms', text: 'Be found by parents, then capture every enquiry with a structured follow-up.', to: '/school-optimisation/administration', icon: 'search' },
    ],
  },
  {
    id: 'smart',
    label: 'Smart Technology',
    tabIcon: 'bolt',
    intro: 'Safety, payments, and communication tools that sit on top of the ERP.',
    items: [
      { title: 'WhatsApp', text: 'Send the same trusted school updates parents already expect on SMS.', to: '/school-optimisation/communication', icon: 'chat' },
      { title: 'RFID & Face Attendance', text: 'Safer campus entry and staff attendance that flows into records automatically.', to: '/school-optimisation/logistics', icon: 'badge' },
      { title: 'GPS Transport', text: 'Give families visibility on routes while transport teams stay in control.', to: '/school-optimisation/logistics', icon: 'pin' },
      { title: 'Payments & QR', text: 'Online fee collection and visitor QR check-in without extra busywork.', to: '/school-optimisation/finance', icon: 'pay' },
    ],
  },
];

export const highlightBlocks = [
  {
    kicker: 'INTELLIGENCE',
    title: 'Smarter systems for smarter schools',
    text: 'Keep departments aligned with one source of truth across the campus.',
    points: ['Cross-department coordination', 'One digital infrastructure', 'Consistent parent and staff experience'],
    to: '/platforms',
    label: 'Explore Platforms',
    icon: 'chart',
  },
  {
    kicker: 'AUTOMATION',
    title: 'Delegate to technology and stay free to lead',
    text: 'Build the process once. Let Bright Study run it every day with a clear audit trail.',
    points: ['Automate repetitive school work', 'Focus on growth, not follow-ups', 'Accountability in every module'],
    to: '/school-optimisation/explore-automation',
    label: 'Explore Automation',
    icon: 'cog',
  },
  {
    kicker: 'GROWTH',
    title: 'Plan before challenges become crises',
    text: 'Spot risk early and act while there is still time to change the outcome.',
    points: ['Catch attendance and fee risk early', 'Forecast academic outcomes', 'Intervene with the right students'],
    to: '/platforms/ai',
    label: 'Explore AI',
    icon: 'bolt',
  },
];

export const suiteTabs = [
  {
    id: 'erp',
    label: 'ERP',
    items: [
      { title: 'Student Information', text: 'One secure record for profiles, documents, and academic history.' },
      { title: 'Fee & Billing', text: 'Structures, collections, receipts, and transparent tracking.' },
      { title: 'Exam & Assessment', text: 'Plan evaluations and publish reliable performance insights.' },
      { title: 'Admission Enquiry', text: 'Follow every lead with a structured path from enquiry to joining.' },
      { title: 'Attendance', text: 'Capture presence quickly and see patterns in real time.' },
      { title: 'Library', text: 'Catalogue, circulation, and records without paper registers.' },
    ],
  },
  {
    id: 'lms',
    label: 'LMS',
    items: [
      { title: 'Lesson Planning', text: 'Structure delivery and keep classroom practice consistent.' },
      { title: 'Resource Library', text: 'Give teachers curated material instead of starting from a blank page.' },
      { title: 'Smart Assessment', text: 'Create, evaluate, and publish results in one workflow.' },
      { title: 'Experiential Learning', text: 'Support activity-led work aligned with NEP classroom expectations.' },
      { title: 'Question Bank', text: 'CBSE-aligned practice for competency-based patterns.' },
      { title: 'Teacher Experience', text: 'Simple navigation so staff adopt the system without a long training curve.' },
    ],
  },
  {
    id: 'website',
    label: 'Website',
    items: [
      { title: 'Modern School Site', text: 'Fast, mobile-first pages that support admissions discovery.' },
      { title: 'Gallery & Stories', text: 'Show activities, achievements, and campus life clearly.' },
      { title: 'Enquiry Capture', text: 'Forms with alerts so no admission lead sits unattended.' },
      { title: 'SEO-ready Content', text: 'Structured pages that help parents find the right school.' },
      { title: 'Accessibility', text: 'Inclusive browsing with reliable protection of school data.' },
      { title: 'CMS Control', text: 'Update notices and pages without waiting on a vendor ticket.' },
    ],
  },
  {
    id: 'ai',
    label: 'AI',
    items: [
      { title: 'Chat Assistant', text: '24/7 answers for common parent, student, and staff questions.' },
      { title: 'Learning Paths', text: 'Practice recommendations based on how each student is doing.' },
      { title: 'Auto-grading Support', text: 'Faster evaluation with clearer feedback loops for teachers.' },
      { title: 'Originality Checks', text: 'Help protect academic integrity across assignments.' },
      { title: 'Content Support', text: 'Draft papers, notes, and practice sets with teacher control.' },
      { title: 'Behaviour Signals', text: 'See engagement, attendance, and participation trends together.' },
    ],
  },
  {
    id: 'analytics',
    label: 'Analytics',
    items: [
      { title: 'Leadership Dashboard', text: 'Admissions, attendance, academics, and finance in one view.' },
      { title: 'Predictive Insights', text: 'Identify at-risk students before the term slips away.' },
      { title: 'Performance Forecasts', text: 'Estimate outcomes so interventions can be planned, not guessed.' },
      { title: 'Group Visibility', text: 'Compare campuses without waiting for a monthly spreadsheet.' },
      { title: 'Fee Intelligence', text: 'Collection health and outstanding risk at a glance.' },
      { title: 'Custom Reports', text: 'The numbers boards and principals actually ask for.' },
    ],
  },
];

export const appFeatures = [
  { title: 'Parents', text: 'Fees, homework, circulars, and transport updates from one login.' },
  { title: 'Teachers', text: 'Attendance, assignments, and class communication without extra apps.' },
  { title: 'Leadership', text: 'Approvals, snapshots, and campus health whenever you need them.' },
];

export const stories = [
  {
    title: 'What happens when a school stops managing chaos and starts leading?',
    text: 'A single campus replaced scattered registers with one platform, cut administrative follow-ups, and gave teachers time back for the classroom.',
    to: '/success-stories/case-studies',
    icon: 'admin',
  },
  {
    title: 'One platform. Many schools. Zero compromise.',
    text: 'Group leadership can see admissions, collections, and academics across campuses — without waiting for each school to send a file.',
    to: '/success-stories/case-studies',
    icon: 'chart',
  },
  {
    title: 'One vision. Several campuses. One connected ecosystem.',
    text: 'Multi-campus teams moved from manual follow-ups to live operations, so principals lead with the same numbers the front office uses.',
    to: '/success-stories/case-studies',
    icon: 'people',
  },
  {
    title: 'Discipline. Data. Digital trust.',
    text: 'Sensitive student records stay in one secure system, with role-based access and the visibility leadership needs to govern calmly.',
    to: '/success-stories/case-studies',
    icon: 'shield',
  },
];

export const whyPoints = [
  {
    title: 'User-friendly interface',
    text: 'Office teams can start with the work they already know. The screens follow daily school tasks, not specialist IT training.',
  },
  {
    title: 'Security and backup',
    text: 'Cloud storage, automated backups, OTP, IP controls, and role-based access keep records recoverable and accountable.',
  },
  {
    title: 'Support that stays',
    text: 'A dedicated help path for school teams and parents — login issues, fee queries, and go-live support included.',
  },
  {
    title: 'Anywhere access',
    text: 'Cloud delivery means principals, teachers, and parents can work from campus, home, or the school bus office.',
  },
  {
    title: 'Clean data migration',
    text: 'Previous-year records can be ported in a planned cutover so the school does not start from a blank database.',
  },
  {
    title: 'Faster communication',
    text: 'Daily remarks, circulars, and alerts reduce the need for parents to visit campus for every small update.',
  },
  {
    title: 'Paperless reporting',
    text: 'Fee, admission, attendance, and academic reports are a click away — with fewer lost files and less reprinting.',
  },
];

export const securityItems = [
  { title: 'Encrypted data store', text: 'Sensitive student and fee information stays protected in transit and at rest.' },
  { title: 'Backup and restore', text: 'Automated backups with a path to restore when something goes wrong.' },
  { title: 'Role-based permissions', text: 'Staff see only what their role should see, with an audit trail behind it.' },
  { title: 'Multi-factor access', text: 'An extra sign-in step for the people who hold the keys to school data.' },
];

export const testimonials = [
  {
    quote: 'Once the major modules were live, our office stopped running after paper files. Attendance, fees, and admissions finally sat in one place.',
    name: 'School Principal',
    org: 'CBSE Senior Secondary School',
  },
  {
    quote: 'The group view is what we needed. Franchise campuses stay on the same process, and the central office can see progress without chasing reports.',
    name: 'Group Director',
    org: 'Multi-campus School Network',
  },
  {
    quote: 'Parents stopped calling for every circular. The app, fee gateway, and homework flow made the school feel organised overnight.',
    name: 'Coordinator',
    org: 'Urban K-12 Campus',
  },
];

export const ecosystemTags = [
  'Schools', 'Students', 'Parents', 'Teachers', 'Admin', 'Attendance', 'Registration',
  'LMS', 'Digital Content', 'Timetable', 'Exam', 'Result', 'Fee', 'Admission',
  'Report Card', 'Transport', 'Library',
];
